// Bağlam temelli soru rozeti — RENK TEK KAYNAĞI (KURALLAR §19.3 md.8).
//
// Tetikleyici (öğretmen, 2026-08-13): *"tüm bağlam temelli sorularda rozetler
// aynı renk olsun."* Rozet DÖRT ayrı yerde basılıyordu ve iki farklı renkteydi:
//
//   App.js  liste grup kartı        bg-indigo-600 text-white   (KOYU)
//   App.js  liste tekil üye         bg-indigo-100 ...          (açık)
//   SoruKarti.js  detay başlığı     bg-indigo-100 ...          (açık)
//   BaglamGrupKarti.js  birleşik    bg-indigo-600 text-white   (KOYU)
//
// Açık ton kanonlaştırıldı: `Maarif 24` / `MEB 18` müfredat rozetleriyle aynı
// ailede durur, listede göz yormaz. Yeni bir basım yeri eklenirse buradan
// okur — sınıf adını kopyalamak drift üretir.

/** Rozetin RENK katmanı (zemin + metin + çerçeve). Boyuttan bağımsızdır. */
export const BAGLAM_ROZET_RENK =
  'bg-indigo-100 text-indigo-800 border border-indigo-300';

/** Liste içi küçük rozet (müfredat rozetlerinin yanında). */
export const BAGLAM_ROZET_KUCUK =
  `px-1.5 py-0.5 rounded text-[9px] font-bold ${BAGLAM_ROZET_RENK}`;

/** Detay/başlık rozeti (birleşik kart ve soru detayı). */
export const BAGLAM_ROZET_BASLIK =
  `px-3 py-1 rounded-md text-sm font-bold tracking-wide ${BAGLAM_ROZET_RENK}`;

/** Soru detayındaki "Soru 1/2" sıra rozeti. */
export const BAGLAM_ROZET_SIRA =
  `inline-block px-2 py-0.5 rounded-md text-sm font-bold ${BAGLAM_ROZET_RENK}`;
